module.exports = __webpack_public_path__ + "static/js/0.ebe90006.chunk.worker.js"